<header class="dialog-header">
  <h2 id="dialogo-sobre-titulo">Sobre o Portugol Webstudio</h2>
  <button type="button" class="icon-btn" aria-label="Fechar" appTooltip="Fechar" (click)="dialogRef.close()">
    <svg-icon src="assets/mdi/close.svg" aria-hidden="true" />
  </button>
</header>

<div class="dialog-body">
  <div class="logo logo-with-badge">
    <svg-icon src="assets/logo/default.svg" svgAriaLabel="Logomarca do Portugol Webstudio" />

    @if (isBeta) {
      <span class="beta-badge">Beta</span>
    }
  </div>

  <p class="app-about">
    O Portugol Webstudio é um ambiente de desenvolvimento integrado (IDE) online para a linguagem de programação
    Portugol (UNIVALI). Foi criado para facilitar o aprendizado de programação de computadores, permitindo que
    estudantes e professores possam escrever, compilar e executar programas de computador diretamente no navegador.
  </p>

  <section class="app-status" aria-labelledby="sobre-versao-titulo">
    <h3 id="sobre-versao-titulo" class="visually-hidden">Versão e atualizações</h3>

    <p class="status-row">
      <svg-icon src="assets/mdi/tag-outline.svg" aria-hidden="true" />
      @if (commitUrl) {
        <span
          >Versão <a class="version" target="_blank" rel="external noopener" [href]="commitUrl">{{ version.label }}</a
          >{{ dateSuffix }}</span
        >
      } @else {
        <span>Versão local, de desenvolvimento</span>
      }
    </p>

    <p class="status-row">
      <svg-icon aria-hidden="true" [src]="offline().icon" />
      <span>{{ offline().text }}</span>
    </p>

    @if (pwa.offlineStatus() === "downloading") {
      <app-progress-bar label="Progresso do download para usar sem internet" [progress]="pwa.offlineProgress()" />
    }

    @if (pwa.offlineStatus() !== "unsupported") {
      <div class="status-row update-row">
        <button type="button" class="btn btn-sm" [disabled]="checking()" (click)="checkForUpdate()">
          <svg-icon src="assets/mdi/refresh.svg" aria-hidden="true" />
          Procurar atualizações
        </button>

        @if (pwa.updateStatus() === "ready") {
          <button type="button" class="btn btn-primary btn-sm" (click)="pwa.reloadToUpdate('sobre')">Atualizar</button>
        }
      </div>

      <p class="update-message" role="status">{{ updateMessage() }}</p>

      @if (pwa.updateStatus() === "downloading") {
        <app-progress-bar label="Progresso do download da atualização" [progress]="pwa.updateProgress()" />
      }
    }
  </section>

  @if (survey.active) {
    <a
      class="btn btn-primary"
      target="_blank"
      rel="external noopener"
      [href]="survey.url"
      (click)="survey.markAnswered('about')"
    >
      <svg-icon src="assets/mdi/clipboard-text-outline.svg" aria-hidden="true" />
      Responder pesquisa
    </a>
  }

  <p class="made-with-love">
    Feito com <svg-icon src="assets/mdi/heart.svg" class="icon-red" svgAriaLabel="amor" /> no
    <svg-icon src="assets/flag-br.svg" svgAriaLabel="Brasil" />
  </p>

  <span role="img" aria-label="Estrelas do projeto no GitHub">
    <svg-icon src="https://img.shields.io/github/stars/dgadelha/Portugol-Webstudio?label=Stars" inert />
  </span>
</div>

<footer class="dialog-footer links">
  <a
    class="btn"
    href="https://github.com/dgadelha/Portugol-Webstudio?utm_source=portugol-webstudio&utm_medium=about_dialog"
    target="_blank"
    rel="external noopener"
    gaEvent="about_source_code"
    gaCategory="about_dialog"
    gaLabel="Código-fonte (diálogo Sobre)"
  >
    <svg-icon src="assets/icon-github.svg" aria-hidden="true" />
    Código-fonte
  </a>

  <a
    class="btn"
    href="https://github.com/dgadelha/Portugol-Webstudio/issues/new?template=bug.yml"
    target="_blank"
    rel="external noopener"
    gaEvent="about_report_bug"
    gaCategory="about_dialog"
    gaLabel="Reportar um problema (diálogo Sobre)"
  >
    <svg-icon src="assets/mdi/bug-outline.svg" class="icon-red" aria-hidden="true" />
    Reportar um problema
  </a>

  <button
    type="button"
    class="btn"
    gaEvent="about_changelog"
    gaCategory="about_dialog"
    gaLabel="Histórico de atualizações (diálogo Sobre)"
    (click)="dialogRef.close('changelog')"
  >
    <svg-icon src="assets/mdi/history.svg" class="icon-blue" aria-hidden="true" />
    Histórico de atualizações
  </button>
</footer>
